import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import parse from "html-react-parser";
import ResizeObserver from "resize-observer-polyfill";
import "./index.css";
import { ComponentMap } from "./componentMap.js";
import PortalContainer from "./PortalContainer.jsx";
import { BrowserRouter } from "react-router-dom";

window.ResizeObserver = ResizeObserver;

function App() {
  const placeholders = Array.from(document.querySelectorAll("[data-id]"));

  return (
    <>
      {placeholders.map((el, index) => {
        const dataId = el.getAttribute("data-id") || "";
        const baseComponent = ComponentMap[dataId] || null;
        const propsFromData = {
          ...el.dataset,
          domElement: el,
        };
        const shouldFadeIn = el.getAttribute("data-appear") === "true";
        const content = parse(el.innerHTML);

        return (
          <PortalContainer
            key={index}
            container={el}
            component={baseComponent}
            props={propsFromData}
            fadeIn={shouldFadeIn}
            fadeContent={content}
            index={index}
          />
        );
      })}
    </>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  let rootElement = document.getElementById("react-master-root");
  if (!rootElement) {
    rootElement = document.createElement("div");
    rootElement.id = "react-master-root";
    document.body.appendChild(rootElement);
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );

  document.querySelectorAll(".fade-in-on-visible").forEach((el) => {
    setTimeout(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("fade-in");
            observer.unobserve(el);
          }
        },
        { threshold: 0.1 },
      );
      observer.observe(el);
    }, 50);
  });
});
const copyLinkBtn = document.querySelector("#copyLinkBtn");
if (copyLinkBtn) {
  copyLinkBtn.addEventListener("click", function () {
    navigator.clipboard
      .writeText(window.location.href)
      .then(function () {
        alert("Link er kopieret til din udklipsholder");
      })
      .catch(function (err) {
        alert("Failed to copy: " + err);
      });
  });
}
const contactEmail = document.querySelectorAll(".contact-email");
if (contactEmail.length) {
  contactEmail.forEach((emailElement) => {
    emailElement.addEventListener("click", function () {
      var email = emailElement.getAttribute("data-email");
      if (!email) {
        alert("Ingen email adresse fundet");
        return;
      }
      navigator.clipboard
        .writeText(email)
        .then(function () {
          alert("emailadressen er kopieret til din udklipsholder");
        })
        .catch(function (err) {
          alert("Failed to copy: " + err);
        });
    });
  });
}

export default App;
